import React from "react";
import { FileUpload } from "@components/FileUpload/FileUpload";
import { useFileUploadProfiles } from "@components/FileUpload/FileUpload.constants";
import { useTranslation } from "react-i18next";
import { MESSAGE_MAX_FILES } from "../constants";

interface MessageFileUploadProps {
  testId: string;
  staged: { name: string; url: string }[];
  disabled: boolean;
  onUpload: (files: File[]) => void;
  onValidationResult?: (message: string | null) => void;
  errorMessage?: string;
}

const MessageFileUpload: React.FC<MessageFileUploadProps> = ({
  testId,
  staged,
  disabled,
  onUpload,
  onValidationResult,
  errorMessage,
}) => {
  const { t } = useTranslation();
  const profiles = useFileUploadProfiles();
  const conditions = { ...profiles.drybulkCargoOpsDocument, hideErrors: false };

  return (
    <FileUpload
      testId={testId}
      maxFiles={MESSAGE_MAX_FILES}
      allowedExtensions={conditions.format.map((ext) => `.${ext}`)}
      conditions={conditions}
      files={staged}
      setFiles={() => undefined}
      disabled={disabled}
      uploadDescription={t("upload.additional-documents-upload", {
        extensions: conditions.format.join(", "),
        size: "10MB",
      })}
      validateDrop={(selectedCount) =>
        staged.length + selectedCount > MESSAGE_MAX_FILES
          ? t("drybulk-cargo-operations.detail.messages.max-files", { count: MESSAGE_MAX_FILES })
          : null
      }
      onValidationResult={onValidationResult}
      errorMessage={errorMessage}
      onUpload={onUpload}
    />
  );
};

export default MessageFileUpload;
